import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import EA from '../helpers/init';

export default EA.Methods.heroSlider = ($this) => {
    const heroSliderEl = $this.querySelector('.hero-swiper');
    const heroSliderPagination = $this.querySelector('.hero-swiper-pagination');

    const heroSlider = new Swiper(heroSliderEl, {
        modules: [Autoplay, Pagination],
        speed: 1200,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: heroSliderPagination,
            clickable: true,
        },
    });
};